<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9999 2C12.3631 2 12.6575 2.29439 12.6575 2.65755V11.3425H21.3425C21.7056 11.3425 22 11.6369 22 12.0001C22 12.3632 21.7056 12.6576 21.3425 12.6576H12.6575V21.3425C12.6575 21.7056 12.3631 22 11.9999 22C11.6368 22 11.3424 21.7056 11.3424 21.3425V12.6576H2.65754C2.29439 12.6576 2 12.3632 2 12.0001C2 11.6369 2.29439 11.3425 2.65754 11.3425H11.3424V2.65755C11.3424 2.29439 11.6368 2 11.9999 2Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9999 2C12.4712 2 12.8533 2.38206 12.8533 2.85335V11.1467H21.1467C21.6179 11.1467 22 11.5288 22 12.0001C22 12.4713 21.6179 12.8534 21.1467 12.8534H12.8533V21.1466C12.8533 21.6179 12.4712 22 11.9999 22C11.5287 22 11.1466 21.6179 11.1466 21.1466V12.8534H2.85334C2.38205 12.8534 2 12.4713 2 12.0001C2 11.5288 2.38205 11.1467 2.85334 11.1467H11.1466V2.85335C11.1466 2.38206 11.5287 2 11.9999 2Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            d="M13.1034 3.10345C13.1034 2.49403 12.6094 2 12 2C11.3906 2 10.8966 2.49403 10.8966 3.10345V10.8966H3.10345C2.49403 10.8966 2 11.3906 2 12C2 12.6094 2.49403 13.1034 3.10345 13.1034H10.8966V20.8966C10.8966 21.506 11.3906 22 12 22C12.6094 22 13.1034 21.506 13.1034 20.8966V13.1034H20.8966C21.506 13.1034 22 12.6094 22 12C22 11.3906 21.506 10.8966 20.8966 10.8966H13.1034V3.10345Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'add-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
